var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('commonPopup',{attrs:{"header":"拼团规则","footer":"我知道了"},on:{"footerClick":_vm.footerClick}},[_c('div',{staticClass:"ctn"},_vm._l((_vm.groupRule),function(item,index){return _c('p',{key:index},[_vm._v(_vm._s(item))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }